import React, { Component } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";

class ExperienceAccordion extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-accord">
        {this.props.sections.map((section) => {
          return (
            <div key={section["title"]} className="experience-section">
              {/* Optional: Show section title if you have multiple sections */}
              {this.props.sections.length > 1 && (
                <div
                  className="experience-section-header"
                  style={{
                    backgroundColor: `${theme.body}`,
                    border: `1px solid ${theme.headerColor}`,
                    borderRadius: `5px`,
                    padding: `15px 20px`,
                    marginBottom: `20px`,
                    fontFamily: "Google Sans Regular",
                    color: `${theme.text}`,
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {section["title"]}
                </div>
              )}
              <div
                className="experience-section-content"
                style={{
                  backgroundColor: `${theme.body}`,
                }}
              >
                {section["experiences"].map((experience, index) => {
                  return (
                    <ExperienceCard
                      key={index}
                      index={index}
                      totalCards={section["experiences"].length}
                      experience={experience}
                      theme={theme}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default ExperienceAccordion;
